class AuthenticationFrontendWithEmailExpiredCodeApiException extends Error {
}

export {
    AuthenticationFrontendWithEmailExpiredCodeApiException
}
